var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { load } from "framework/state/loader";
import { NoEntityError } from "framework/validation/validatableentity";
import { updateByCollectionResponse } from "framework/state/collection";
import { apiGetCompCompetitors } from "./endpoint";
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var loadCompCompetitors = function () {
    return function (store) {
        var loader = function () { return apiGetCompCompetitors(); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft, response);
                draft.collection.sort(function (a, b) { return a.order - b.order; });
            });
        };
        load(store, loader, stateProducer);
    };
};
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadCompCompetitors: loadCompCompetitors,
    },
    name: "CompetitioIndexesCompCompetitor"
});
var useState = createHook(store);
export { StateDefaults as CompetitioIndexesCompCompetitorDefaults, useState as useCompetitioIndexesCompCompetitor, };
